"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var HeadingCountdownModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingCountdownModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
const services_1 = require("../../services");
const HeadingCountdown_contracts_1 = require("./HeadingCountdown.contracts");
const DateTimePicker_contracts_1 = require("../../dsl/dashmix/DateTimePicker/DateTimePicker.contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `HeadingCountdown`'s contents.
 *
 * @author Adrian Gajos <adrian.gajos@movecloser.pl>
 */
let HeadingCountdownModuleForm = HeadingCountdownModuleForm_1 = class HeadingCountdownModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = HeadingCountdownModuleForm_1.getInitialContent();
        this.DateTimePickerType = DateTimePicker_contracts_1.DateTimePickerType;
        this.icons = backoffice_1.DashmixIconName;
        /**
         * The image to render.
         */
        this.img = null;
        /**
         * The image caption to show.
         */
        this.imgCaption = '';
    }
    /**
     * Watch for changes in backgroundColor and clear it if black color is selected
     */
    onBackgroundColorChange(newValue) {
        if (newValue && newValue.toLowerCase() === '#000000') {
            this._content.backgroundColor = '';
        }
    }
    /**
     * Returns a list of options for the heading level select field.
     * Each option represents a heading level from 1 to 6.
     */
    get headingOptions() {
        const options = [];
        for (let i = 1; i < 7; i++) {
            options.push({
                label: `${i}`,
                value: i
            });
        }
        return options;
    }
    /**
     * Check that image is defined
     */
    hasImage() {
        return !!this._content.image && typeof this._content.image.value !== 'undefined';
    }
    /**
     * Get image source form picker
     */
    findImageSource() {
        this.pickRelated(services_1.Picker.Media, this.setImageSource);
    }
    /**
     * Set image selected form picker
     */
    setImageSource(source) {
        this._content.image = source;
        this._content.imageRatio = _contracts_1.ImageRatio.Original;
        this.$nextTick(() => {
            this.findImageRelated();
        });
    }
    /**
     * Get image to render from related services
     */
    findImageRelated() {
        if (typeof this._content.image === 'undefined' || !this.hasImage()) {
            return;
        }
        const related = this.relatedService.resolve(this._content.image, {});
        if (!this.isPromise(related)) {
            return;
        }
        related.then((related) => {
            if (Object.prototype.hasOwnProperty.call(related, 'caption')) {
                this.imgCaption = related.caption;
            }
            if (Object.prototype.hasOwnProperty.call(related, 'file')) {
                this.img = {
                    thumbnail: related.url
                };
            }
            else if (Object.prototype.hasOwnProperty.call(related, 'url')) {
                this.img = {
                    thumbnail: related.url
                };
            }
        }).catch(error => {
            console.debug(error);
        });
    }
    /**
     * Check if value is promise
     */
    isPromise(value) {
        return value && typeof value.then === 'function';
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.HeadingCountdown,
            size: {
                colSpan: 6,
                rowSpan: 1,
                minColSpan: 2,
                minRowSpan: 1,
                isResizable: true
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            level: 1,
            text: '',
            useImage: false,
            showCountdown: false,
            countdownTarget: null,
            countdownBoxColor: HeadingCountdown_contracts_1.DEFAULT_COUNTDOWN_COLORS.BOX_COLOR,
            countdownTextColor: HeadingCountdown_contracts_1.DEFAULT_COUNTDOWN_COLORS.TEXT_COLOR,
            countdownPrefix: '',
            backgroundColor: '',
            externalLink: '',
            useAsAd: false
        };
    }
};
__decorate([
    vue_property_decorator_1.Watch('_content.backgroundColor'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], HeadingCountdownModuleForm.prototype, "onBackgroundColorChange", null);
HeadingCountdownModuleForm = HeadingCountdownModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'HeadingCountdownModuleForm',
        components: { DashmixInput: backoffice_1.DashmixInput, DashmixSelect: backoffice_1.DashmixSelect, DashmixCheck: backoffice_1.DashmixCheck, FormErrors: form_2.FormErrors, DashmixDateTimePicker: backoffice_1.DashmixDateTimePicker, DashmixButton: backoffice_1.DashmixButton },
        mounted() {
            if (this._content.image) {
                this.findImageRelated();
            }
        },
        template: `
    <div>
      <div class="form-group">
        <label for="level">{{ $t('forms.headingCountdown.level') }}</label>
        <DashmixSelect name="level" :model.sync="_content.level" :options="headingOptions"/>
      </div>

      <div class="form-group">
        <label for="text">{{ $t('forms.headingCountdown.content') }}</label>
        <DashmixInput name="text" :model.sync="_content.text"/>
      </div>

      <div class="form-group">
        <DashmixCheck :label="$t('forms.headingCountdown.useImage')" name="useImage" :model.sync="_content.useImage"/>
      </div>

      <template v-if=_content.useImage>
        <div class="row">
          <div class="col">
            <DashmixButton variant="alt" :icon="icons.SearchSolid" :label="$t('forms.shared.search')"
                           @click="findImageSource"/>
          </div>
        </div>

        <div v-if="hasImage()" class="row pt-3">
          <div v-if="img" class="col-6">
            <p class="mb-3"><b>{{ $t('forms.image.selected') }}</b></p>
            <figure class="image-form__figure">
              <img :src="img.thumbnail" class="img-fluid"/>
              <figcaption>{{ imgCaption }}</figcaption>
            </figure>
          </div>
        </div>
      </template>

      <div class="form-group">
        <label for="externalLink">{{ $t('forms.headingCountdown.externalLink') }}</label>
        <DashmixInput name="externalLink" :model.sync="_content.externalLink"/>
        <small class="form-text text-muted">{{ $t('forms.headingCountdown.externalLinkHelp') }}</small>
      </div>

      <div class="form-group">
        <DashmixCheck :label="$t('forms.headingCountdown.useAsAd')" name="useAsAd" :model.sync="_content.useAsAd"/>
      </div>

      <div class="form-group">
        <label for="backgroundColor">{{ $t('forms.headingCountdown.backgroundColor') }}</label>
        <DashmixInput name="backgroundColor" type="color" :model.sync="_content.backgroundColor"/>
        <small class="form-text text-muted">{{ $t('forms.headingCountdown.backgroundColorHelp') }}</small>
      </div>

      <div class="form-group">
        <DashmixCheck :label="$t('forms.headingCountdown.showCountdown')" name="showCountdown"
                      :model.sync="_content.showCountdown"/>
      </div>

      <template v-if="_content.showCountdown">
        <div class="form-group">
          <label for="countdownPrefix">{{ $t('forms.headingCountdown.countdownPrefix') }}</label>
          <DashmixInput name="countdownPrefix" :model.sync="_content.countdownPrefix"/>
        </div>

        <div class="form-group">
          <label for="countdownTarget">{{ $t('forms.headingCountdown.countdownTarget') }}</label>
          <DashmixDateTimePicker
            name="countdownTarget"
            :model.sync="_content.countdownTarget"
            :pickerType="DateTimePickerType.DateTime"
            format="YYYY-MM-DD HH:mm"
            valueType="YYYY-MM-DDTHH:mm:ss"/>
        </div>

        <div class="form-group">
          <label for="countdownBoxColor">{{ $t('forms.headingCountdown.countdownBoxColor') }}</label>
          <DashmixInput name="countdownBoxColor" type="color" :model.sync="_content.countdownBoxColor"/>
        </div>

        <div class="form-group">
          <label for="countdownTextColor">{{ $t('forms.headingCountdown.countdownTextColor') }}</label>
          <DashmixInput name="countdownTextColor" type="color" :model.sync="_content.countdownTextColor"/>
        </div>
      </template>

      <!-- Form errors -->
      <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3"/>
    </div>
  `
    })
], HeadingCountdownModuleForm);
exports.HeadingCountdownModuleForm = HeadingCountdownModuleForm;
//# sourceMappingURL=HeadingCountdown.form.js.map